import './Faq.scss';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import categories from '../../../FAQData';
import XpektorSlider from '../../../Components/XpektorSlider/XpektorSlider';
import Question from './Question';
import IconButton from '../../../Components/IconButton/IconButton';

const gT = (t, key) => t(`${key}`);

export default function Faq() {
  const { t } = useTranslation('faq');
  const [category, setCategory] = useState(categories[0].id);

  useEffect(() => {
    document.title = gT(t, 'document-title');
  }, [t]);

  return (
    <div className="faq-wrapper">
      <p className="faq-title">{gT(t, 'title')}</p>
      <div className="faq-nav-container">
        {categories.map((categoryItem) => (
          <IconButton
            title={categoryItem.name}
            active={categoryItem.id === category}
            key={categoryItem.id}
            onClick={() => setCategory(categoryItem.id)}
            icon={categoryItem.icon}
          />
        ))}
      </div>
      <XpektorSlider activeSlideIndex={category}>
        {categories.map((categoryItem) => (
          <XpektorSlider.Slide
            key={categoryItem.id}
            hidden={category !== categoryItem.id}
          >
            <div className="faq-content">
              {categoryItem.questions.map((questionItem) => (
                <Question question={questionItem} key={questionItem.id} />
              ))}
            </div>
          </XpektorSlider.Slide>
        ))}
      </XpektorSlider>
    </div>
  );
}
